const mailingAddress = (
	`{
		id
		address1
		address2
		city
		company
		country
		firstName
		formatted
		lastName
		latitude
		longitude
		phone
		province
		zip
		name
		countryCode: countryCodeV2
		provinceCode
	}`
);

const customer = (
	`{
		id
		email
		firstName
		lastName
		phone
		tags
		defaultAddress ${mailingAddress}
	}`
);

const accessToken = (
	`{
		accessToken
		expiresAt
	}`
);

export { accessToken };
export default customer;
